<div class="d-flex m-0">
  <div class="col-lg-7 home-left-side">
    <app-information></app-information>
  </div>
  <div class="col-lg-5 no-padding home-right-side">
    <app-code (discountCode)="checkDiscountCode($event)" [errText]="errText" [appliedCode]="appliedCode" [schoolName]="schoolName"></app-code>
  </div>
</div>
<app-query-params-ls></app-query-params-ls>
